import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AiSidebarProvider } from '@mint-lib/ai-sidebar-circuit';
import { usePreviousValue } from '@mint-lib/hooks';
import { usePermissions } from '@mint-lib/profile-helpers';
import { AnyAction } from 'redux';

import { useCampaignDataSelector } from '../../hooks/useGetCampaignData.js';
import useSettingsNotifications from '../../hooks/useSettingsNotifications.jsx';
import {
  changeRecommendationsSettingsActions,
  getRecommendationsSettingsActions,
  recommendationsActions,
  recommendationsActionsGoal,
} from '../../redux/action/api/RecommendationsApi.js';
import { getRecommendationsSettingsState } from '../../redux/selector/recommendations.js';
import { getRecosSettingsPrioritisationGoal } from '../../redux/selector/RecoSettingsPrioritisationGoal.js';
import { RecommendationsSettings } from '../../types/Recommendations.js';
import RecommendationsPanel from '../Builder/RecommendationsPanel/RecommendationsPanel.jsx';

type Props = {
  onClosePanel?: () => void;
};

const RecommendationPanelPage = ({ onClosePanel = () => {} }: Props) => {
  const dispatch = useDispatch();

  const { data: journeyId } = useCampaignDataSelector('id');

  const recoSettingsPriritisationGoal = useSelector(
    getRecosSettingsPrioritisationGoal,
  );

  const {
    isLoading: recommendationsSettingsLoadingState,
    error: recommendationsSettingsErrorState,
    ...recommendationsSettings
  } = useSelector(getRecommendationsSettingsState);

  const prevRecommendationSettingsLoadingState = usePreviousValue(
    recommendationsSettingsLoadingState,
  );

  const [lastRequestAction, setLastRequestAction] = useState<AnyAction | null>(
    null,
  );

  const { permissions } = usePermissions();
  const isNonFinancialUser = !permissions.financialDataFeature;

  useSettingsNotifications({
    prevLoadingState: prevRecommendationSettingsLoadingState,
    loadingState: recommendationsSettingsLoadingState,
    errorState: recommendationsSettingsErrorState,
    retryAction: () => dispatch(lastRequestAction!),
  });

  useEffect(() => {
    if (!isNonFinancialUser && journeyId) {
      dispatch(recommendationsActions.request({ pageSize: 10, journeyId }));
      dispatch(getRecommendationsSettingsActions.request(journeyId));
      dispatch(recommendationsActionsGoal.request({ journeyId }));
    }
  }, [isNonFinancialUser, journeyId]);

  const handleOnChangeRecommendationsSettings = (
    settings: Partial<RecommendationsSettings>,
  ) => {
    const action = changeRecommendationsSettingsActions.request({
      journeyId,

      parameters: settings,
    });

    setLastRequestAction(action);

    dispatch(action);

    setTimeout(() => {
      dispatch(recommendationsActionsGoal.request({ journeyId }));
    }, 1000);
  };

  return (
    <div className="flex h-full w-313 flex-row">
      <AiSidebarProvider>
        <RecommendationsPanel
          recommendationsSettings={recommendationsSettings}
          recoSettingsPriritisationGoal={recoSettingsPriritisationGoal}
          onChangeRecommendationsSettings={
            handleOnChangeRecommendationsSettings
          }
          onCloseModal={onClosePanel}
        />
      </AiSidebarProvider>
    </div>
  );
};
export default RecommendationPanelPage;
